export default {
  Circle: 'circle',
  Line: 'line',
  Arrow: 'arrow',
  Pencil: 'pencil',
  Rectangle: 'rectangle',
  Select: 'select',
  Pan: 'pan',
}
